import React from "react";
import { cn } from "../lib/utils";

interface Props {
  className?: string;
  imageSrc?: string;
  imageAlt?: string;
}

export default function MobileMockup({ className, imageSrc, imageAlt }: Props) {
  return (
    <div className={cn("relative mx-auto aspect-[9/19] w-full overflow-hidden rounded-[24px] sm:rounded-[28px] md:rounded-[32px] lg:rounded-[40px]", className)}>
      {/* Screen content */}
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={imageAlt || "App screenshot"}
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 p-4">
          <div className="h-10 w-10 rounded-md bg-indigo-600/20" />
          <div className="mt-4 h-6 w-2/3 rounded bg-neutral-800" />
          <div className="mt-2 h-4 w-1/2 rounded bg-neutral-800" />
          <div className="mt-6 rounded-lg border border-neutral-800 p-4">
            <div className="h-24 rounded bg-[radial-gradient(circle_at_center,rgba(99,102,241,0.35),transparent_60%)]" />
            <div className="mt-3 h-4 w-2/3 rounded bg-neutral-800" />
          </div>
          <div className="mt-4 grid grid-cols-2 gap-3">
            <div className="h-10 rounded bg-indigo-600/80" />
            <div className="h-10 rounded bg-neutral-800" />
          </div>
        </div>
      )}
    </div>
  );
}
